import { Helmet } from 'react-helmet-async';

interface SEOMetaProps {
    title?: string;
    description?: string;
    image?: string;
    url?: string;
    type?: 'website' | 'article' | 'product';
}

const DEFAULT_TITLE = 'Custom Map Posters | Suunnittele Korkealaatuisia Karttajulisteita';
const DEFAULT_DESCRIPTION = 'Luo korkealaatuisia kustomoituja karttajulisteita mistä tahansa sijainnista. Premium-tasoinen personoitu lahja ja sisustuselementti upeilla yksityiskohdilla. Suunnittele oma uniikki karttasi tänään.';
const DEFAULT_IMAGE = '/og-image.jpg'; // We should create this placeholder or use a real one
const SITE_URL = 'https://maps-configurator.pages.dev'; // Replace with actual domain if different

export const SEOMeta = ({
    title = DEFAULT_TITLE,
    description = DEFAULT_DESCRIPTION,
    image = DEFAULT_IMAGE,
    url = SITE_URL,
    type = 'website'
}: SEOMetaProps) => {
    const fullTitle = title === DEFAULT_TITLE ? title : `${title} | Custom Map Posters`;
    const fullUrl = url.startsWith('http') ? url : `${SITE_URL}${url}`;
    const fullImage = image.startsWith('http') ? image : `${SITE_URL}${image}`;

    return (
        <Helmet>
            {/* Standard Meta Tags */}
            <title>{fullTitle}</title>
            <meta name="description" content={description} />
            <link rel="canonical" href={fullUrl} />

            {/* Open Graph / Facebook */}
            <meta property="og:type" content={type} />
            <meta property="og:url" content={fullUrl} />
            <meta property="og:title" content={fullTitle} />
            <meta property="og:description" content={description} />
            <meta property="og:image" content={fullImage} />

            {/* Twitter */}
            <meta property="twitter:card" content="summary_large_image" />
            <meta property="twitter:url" content={fullUrl} />
            <meta property="twitter:title" content={fullTitle} />
            <meta property="twitter:description" content={description} />
            <meta property="twitter:image" content={fullImage} />
        </Helmet>
    );
};
